/**
 * Hides the mobile sidebar-form sticky CTA once the form itself is on screen,
 * so the bar does not cover the fields or the submit button.
 */
export default class FormStickyCta {
  constructor() {
    this.bar = document.querySelector(".form-sticky-cta");
    this.form = document.getElementById("form");
    this.target = this.form ? this.form.closest("aside") || this.form : null;
    this.mediaQuery = window.matchMedia("(max-width: 767.98px)");
    this.observer = null;

    if (!this.bar || !this.target) {
      return;
    }

    this.mediaQuery.addEventListener("change", () => this.handleMediaChange());
    this.handleMediaChange();
  }

  handleMediaChange() {
    this.disconnect();

    if (!this.mediaQuery.matches) {
      this.bar.classList.remove("is-hidden");
      return;
    }

    this.observer = new IntersectionObserver(
      ([entry]) => {
        this.bar.classList.toggle("is-hidden", entry.isIntersecting);
      },
      {
        threshold: 0,
        rootMargin: "0px 0px -92px 0px",
      }
    );

    this.observer.observe(this.target);
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  }
}
